<template>
    <div id="SystemOptions">
        <div class="dust-container">
            <div v-for="n in 30" :key="n" 
                 class="dust-particle"
                 :style="{
                     '--size': `${2 + Math.random() * 4}px`,
                     '--left': `${Math.random() * 100}%`,
                     '--delay': `${Math.random() * 2}s`
                 }">
            </div>
        </div>
        <div class="title-text">
            <h1>{{ $t("aiTechnologyExperienceText") }}</h1>
            <h3 v-html="$t('multipleSystemsText')"></h3>
        </div>
        <div class="content">
            <!--kart 1-->
            <div class="card" @click="toggleCheckbox('aiChatbot')">
                <div class="card-header">
                    <ChatbotFill class="icon" />
                    <span class="card-title">{{ $t("aiChatBotText") }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="selectedSystems.aiChatbot" @click.stop />
                        <span class="checkmark" @click="toggleCheckbox('aiChatbot')"></span>
                    </label>
                </div>
                <div class="card-text">
                    {{ $t("aiChatbotManagementText") }}
                </div>
            </div>
            <!--kart 2-->
            <div class="card" @click="toggleCheckbox('aiAssistant')">
                <div class="card-header">
                    <AiAsistant class="icon" />
                    <span class="card-title">{{ $t("aiAssistantText") }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="selectedSystems.aiAssistant" />
                        <span class="checkmark" @click="toggleCheckbox('aiAssistant')"></span>
                    </label>
                </div>
                <div class="card-text">{{ $t("aiAssistantManagementText") }}</div>
            </div>
            <!--kart 3-->
            <div class="card" @click="toggleCheckbox('aiLiveSupport')">
                <div class="card-header">
                    <LiveSupport class="icon" />
                    <span class="card-title">{{ $t("aiLiveSupportText") }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="selectedSystems.aiLiveSupport" />
                        <span class="checkmark" @click="toggleCheckbox('aiLiveSupport')"></span>
                    </label>
                </div>
                <div class="card-text">
                    {{ $t("aiLiveSupportManagementText") }}
                </div>
            </div>
            <!--kart 4-->
            <div class="card" @click="toggleCheckbox('aiAutomation')">
                <div class="card-header">
                    <AutomationIcon class="icon" />
                    <span class="card-title">{{ $t("aiAutomationText") }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="selectedSystems.aiAutomation" />
                        <span class="checkmark" @click="toggleCheckbox('aiAutomation')"></span>
                    </label>
                </div>
                <div class="card-text">
                    {{ $t("aiAutomationManagementText") }}
                </div>
            </div>
            <!--kart 5-->
            <div class="card" @click="toggleCheckbox('aiDynamicCrm')">
                <div class="card-header">
                    <TaskIcon class="icon" />
                    <span class="card-title">{{ $t("aiDynamicCrmText") }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="selectedSystems.aiDynamicCrm" />
                        <span class="checkmark" @click="toggleCheckbox('aiDynamicCrm')"></span>
                    </label>
                </div>
                <div class="card-text">
                    {{ $t("aiDynamicCrmManagementText") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatbotFill from "../../icon/ChatbotFill.vue";
import AiAsistant from "../../icon/AiAsistant.vue";
import LiveSupport from "../../icon/LiveSupport.vue";
import TaskIcon from "../../icon/TaskIcon.vue";
import AutomationIcon from "../../icon/AutomationIcon.vue";
import { saveToLocalStorage, loadFromLocalStorage } from "../../../utils/formStore";

export default {
    name: "SystemOptions",
    components: {
        ChatbotFill,
        AiAsistant,
        LiveSupport,
        TaskIcon,
        AutomationIcon
    },
    data() {
        return {
            selectedSystems: {
                aiChatbot: false,
                aiAssistant: false,
                aiLiveSupport: false,
                aiAutomation: false,
                aiDynamicCrm: false,
            },
        };
    },
    methods: {
        toggleCheckbox(system) {
            this.selectedSystems[system] = !this.selectedSystems[system];
        },
    },
    watch: {
        selectedSystems: {
            handler(newVal) {
                saveToLocalStorage({ 
                    systemOptions: newVal 
                });
            },
            deep: true
        }
    },
    created() {
        const saved = loadFromLocalStorage().systemOptions || {};
        this.selectedSystems = {
            aiChatbot: saved.aiChatbot || false,
            aiAssistant: saved.aiAssistant || false,
            aiLiveSupport: saved.aiLiveSupport || false,
            aiAutomation: saved.aiAutomation || false,
            aiDynamicCrm: saved.aiDynamicCrm || false
        };
    }
};
</script>

<style lang="scss" scoped>
@use "sass:math";

#SystemOptions {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    background-image: url("../../../assets/BackgroundTwo.png");
    background-repeat: no-repeat;
    background-size: cover;

    .dust-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 1;
        -webkit-perspective: 1000px;
        perspective: 1000px;
    }

    .dust-particle {
        position: absolute;
        width: var(--size);
        height: var(--size);
        left: var(--left);
        top: -20px;
        background: rgba(93, 91, 141, 0.15);
        border-radius: 50%;
        -webkit-animation: dustAnimation 4s ease-in-out forwards;
        animation: dustAnimation 4s ease-in-out forwards;
        animation-delay: var(--delay);
        -webkit-animation-delay: var(--delay);
        
        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: inherit;
            border-radius: inherit;
            -webkit-animation: dustPulse 2s ease-in-out forwards;
            animation: dustPulse 2s ease-in-out forwards;
        }
    }

    @-webkit-keyframes dustAnimation {
        0% {
            opacity: 0;
            -webkit-transform: translateY(0) rotate(0deg);
            transform: translateY(0) rotate(0deg);
        }
        20% {
            opacity: 1;
        }
        90% {
            opacity: 0;
        }
        100% {
            opacity: 0;
            -webkit-transform: translateY(100vh) rotate(360deg);
            transform: translateY(100vh) rotate(360deg);
        }
    }

    @keyframes dustAnimation {
        0% {
            opacity: 0;
            transform: translateY(0) rotate(0deg);
        }
        20% {
            opacity: 1;
        }
        90% {
            opacity: 0;
        }
        100% {
            opacity: 0;
            transform: translateY(100vh) rotate(360deg);
        }
    }

    @-webkit-keyframes dustPulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
    }

    @keyframes dustPulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
    }

    .title-text {
        position: relative;
        z-index: 2;
        opacity: 0;
        -webkit-animation: fadeInDown 1s ease-out forwards;
        animation: fadeInDown 1s ease-out forwards;
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;

        @media (max-width: 768px) {
            h1 {
                font-size: 1.5rem !important;
                padding: 0 15px;
            }

            h3 {
                font-size: 1.17rem !important;
                padding: 0 15px;
            }
        }

        @media (max-width: 480px) {
            h1 {
                font-size: 1.8rem;
            }
        }
    }

    .content {
        position: relative;
        z-index: 2;
        padding: 0 20px;

        @media (max-width: 1200px) {
            gap: 15px;
        }

        .card {
            opacity: 0;
            -webkit-transform: translateY(20px);
            transform: translateY(20px);
            -webkit-animation: fadeInUp 0.6s ease-out forwards;
            animation: fadeInUp 0.6s ease-out forwards;
            
            @for $i from 1 through 5 {
                &:nth-child(#{$i + 1}) {
                    -webkit-animation-delay: #{0.8 + $i * 0.15}s;
                    animation-delay: #{0.8 + $i * 0.15}s;
                }
            }

            @media (max-width: 1200px) {
                width: calc(50% - 20px);
                min-width: 300px;
                padding: 20px;
            }

            @media (max-width: 768px) {
                width: 100%;
                max-width: 500px;
            }

            .card-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;

                .icon {
                    font-size: 2rem;
                    color: #5d5b8d;
                }

                .card-title {
                    font-size: 1.2rem;
                    font-weight: bold;
                    color: #272657;
                    flex-grow: 1;
                    margin-left: 10px;
                    text-align: left;
                }

                .checkbox {
                    position: relative;
                    cursor: pointer;

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;

                        &:checked ~ .checkmark {
                            background-color: #5d5b8d;
                            border: 1px solid #5d5b8d;
                        }

                        &:checked ~ .checkmark::after {
                            display: block;
                        }
                    }

                    .checkmark {
                        height: 24px;
                        width: 24px;
                        background-color: #fff;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;

                        &::after {
                            content: "";
                            position: absolute;
                            display: none;
                            left: 8px;
                            top: 4px;
                            width: 6px;
                            height: 10px;
                            border: solid #fff;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                        }
                    }
                }

                @media (max-width: 768px) {
                    .card-title {
                        font-size: 1.1rem;
                    }

                    .icon {
                        font-size: 1.8rem;
                    }
                }
            }

            .card-text {
                font-family: 'Plus Jakarta Sans', sans-serif;
                color: #64607D;
                font-size: 1.3rem;
                text-align: left;

                @media (max-width: 768px) {
                    font-size: 1.1rem;
                }

                @media (max-width: 480px) {
                    font-size: 1rem;
                }
            }
        }
    }

    @-webkit-keyframes fadeInDown {
        from {
            opacity: 0;
            -webkit-transform: translateY(-30px);
            transform: translateY(-30px);
        }
        to {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    }

    @keyframes fadeInDown {
        from {
            opacity: 0;
            transform: translateY(-30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @-webkit-keyframes fadeInUp {
        from {
            opacity: 0;
            -webkit-transform: translateY(20px);
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        margin-bottom: 20px;
        text-align: center;

        h1 {
            font-size: 2.3rem;
            color: #272657;
            font-weight: bold;
        }

        h3 {
            color: #64607D;
            font-weight: 100;
            font-size: 1.17rem;
        }
    }

    .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;

        .card {
            background: #fff;
            border: 1px solid #ccc;
            border-radius: 20px;
            width: 350px;
            padding: 30px;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
            cursor: pointer;
            transition: border 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                border-color: #5d5b8d;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            }

            .card-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;

                .icon {
                    font-size: 2rem;
                    color: #5d5b8d;
                }

                .card-title {
                    font-size: 1.2rem;
                    font-weight: bold;
                    color: #272657;
                    flex-grow: 1;
                    margin-left: 10px;
                    text-align: left;
                }

                .checkbox {
                    position: relative;
                    cursor: pointer;

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;

                        &:checked ~ .checkmark {
                            background-color: #5d5b8d;
                            border: 1px solid #5d5b8d;
                        }

                        &:checked ~ .checkmark::after {
                            display: block;
                        }
                    }

                    .checkmark {
                        height: 24px;
                        width: 24px;
                        background-color: #fff;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;

                        &::after {
                            content: "";
                            position: absolute;
                            display: none;
                            left: 8px;
                            top: 4px;
                            width: 6px;
                            height: 10px;
                            border: solid #fff;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                        }
                    }
                }
            }

            .card-text {
                font-family: 'Plus Jakarta Sans', sans-serif;
                color: #64607D;
                font-size: 1rem;
                text-align: left;
            }
        }
    }

    @media (max-width: 768px) {
        height: 100vh;
        overflow-y: auto;
        padding-bottom: 40px;

        .content {
            max-height: calc(100vh - 150px);
            padding: 0 15px 20px 15px;

            &::-webkit-scrollbar {
                width: 6px;
            }
            
            &::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, 0.1);
                border-radius: 10px;
            }
            
            &::-webkit-scrollbar-thumb {
                background: rgba(93, 91, 141, 0.5);
                border-radius: 10px;
            }

            .card {
                margin-bottom: 15px;
                width: calc(100% - 10px);
                max-width: none;
            }
        }

        .title-text {
            padding: 20px 15px;
            margin-bottom: 15px;
        }
    }
}
</style>